import Vue from 'vue'
import Router from 'vue-router'
import index from '@/components/index'
import productCenter from '@/components/productCenter'
import stockUniverse from '@/components/stockUniverse'
import investTeam from '@/components/investTeam'
import investCenter from '@/components/investCenter'
import lawColumn from '@/components/lawColumn'
import information from '@/components/information'
import informatDetail from '@/components/informatDetail'
import about from '@/components/about'
import lawcDetail from '@/components/lawcDetail'
import education from '@/components/education'
import teacherVideo from '@/components/educationView/teacherVideo'
import subjectVideo from '@/components/educationView/subjectVideo'
import B05_gsdt from '@/components/aboutS/B05_gsdt'
import B08_cpyc from '@/components/aboutS/B08_cpyc'
import B10_xgsm from '@/components/aboutS/B10_xgsm'
import B04_djzl from '@/components/aboutS/B04_djzl'
import C01_dcjys from '@/components/aboutS/C01_dcjys' //德才院隐私

// 产品中心
import ddzb from '@/components/productCenter/ddzb' //大德周报
import ztcl from '@/components/productCenter/ztcl' //主题策略
import dxsf from '@/components/productCenter/dxsf' //德迅算法
import dxzg from '@/components/productCenter/dxzg' //德迅证顾
import jys from '@/components/productCenter/jys' //交易师
import zgds from '@/components/productCenter/zgds' //诊股大师
import ddzs from '@/components/productCenter/ddzs' //大德专属
import ddjy from '@/components/productCenter/ddjy' //大德精研
//股宇宙
import gyzxz from '@/components/stockUniverse/gyzxz' //股宇宙下载页
Vue.use(Router)


const VueRouterPush = Router.prototype.push
Router.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch(err => err)
}


export default new Router({
  mode: 'history',
  // base:'/index/',
  routes: [
    {
      path: '/index',
      redirect: '/'
    },
    {
      path: '/',
      name: 'index',
      component: index,
      meta: {
        title: '财富在线——金融科技领域湾区标杆',
        keywords: '证券投资,投资机构,徳讯证券,徳讯证顾',
        description:'粤港澳大湾区的专业证券顾问机构,致力于为中国投资人孵化财富,为非专业人搭建学习平台,让每个人都能成为合格的投资者.'
      }
    },
    {
      path: '/productCenter',
      name: 'productCenter',
      component: productCenter,
      meta: {
        title: '财富在线——金融科技领域湾区标杆',
        keywords: '证券投资,投资机构,徳讯证券,徳讯证顾',
        description:'粤港澳大湾区的专业证券顾问机构,致力于为中国投资人孵化财富,为非专业人搭建学习平台,让每个人都能成为合格的投资者666.'
      }
      /* 产品中心 */
    },
    {
      path: '/investTeam',
      name: 'investTeam',
      component: investTeam,
      meta: {
        title: '财富在线——金融科技领域湾区标杆',
        // keywords: '证券投资,投资机构,徳讯证券,徳讯证顾',
        // description:'粤港澳大湾区的专业证券顾问机构,致力于为中国投资人孵化财富,为非专业人搭建学习平台,让每个人都能成为合格的投资者666.'
      }
    },
    {
      path: '/investCenter',
      name: 'investCenter',
      component: investCenter,
      meta: {
        title: '财富在线——金融科技领域湾区标杆',
        // keywords: '证券投资,投资机构,徳讯证券,徳讯证顾',
        // description:'粤港澳大湾区的专业证券顾问机构,致力于为中国投资人孵化财富,为非专业人搭建学习平台,让每个人都能成为合格的投资者666.'
      }
    },
    {
      path: '/education',
      name: 'education',
      component: education,
      meta: {
        title: '财富在线——金融科技领域湾区标杆',
        // keywords: '证券投资,投资机构,徳讯证券,徳讯证顾',
        // description:'粤港澳大湾区的专业证券顾问机构,致力于为中国投资人孵化财富,为非专业人搭建学习平台,让每个人都能成为合格的投资者666.'
      }
    },
    {
      path: '/information',
      name: 'information',
      component: information,
      meta: {
        title: '财富在线——金融科技领域湾区标杆',
        // keywords: '证券投资,投资机构,徳讯证券,徳讯证顾',
        // description:'粤港澳大湾区的专业证券顾问机构,致力于为中国投资人孵化财富,为非专业人搭建学习平台,让每个人都能成为合格的投资者666.'
      }
    },
    {
      path: '/informatDetail',
      name: 'informatDetail',
      component: informatDetail,
      meta: {
        title: '财富在线——金融科技领域湾区标杆',
        // keywords: '证券投资,投资机构,徳讯证券,徳讯证顾',
        // description:'粤港澳大湾区的专业证券顾问机构,致力于为中国投资人孵化财富,为非专业人搭建学习平台,让每个人都能成为合格的投资者666.'
      }
    },
    {
      path: '/stockUniverse',
      name: 'stockUniverse',
      component: stockUniverse,
      meta: {
        title: '财富在线——金融科技领域湾区标杆',
        // keywords: '证券投资,投资机构,徳讯证券,徳讯证顾',
        // description:'粤港澳大湾区的专业证券顾问机构,致力于为中国投资人孵化财富,为非专业人搭建学习平台,让每个人都能成为合格的投资者666.'
      }
    },
    {
      path: '/lawColumn',
      name: 'lawColumn',
      component: lawColumn,
      meta: {
        title: '财富在线——金融科技领域湾区标杆',
        // keywords: '证券投资,投资机构,徳讯证券,徳讯证顾',
        // description:'粤港澳大湾区的专业证券顾问机构,致力于为中国投资人孵化财富,为非专业人搭建学习平台,让每个人都能成为合格的投资者666.'
      }
      /* 打非专栏 */
    },
    {
      path: '/lawcDetail',
      name: 'lawcDetail',
      component: lawcDetail,
      meta: {
        title: '财富在线——金融科技领域湾区标杆',
        // keywords: '证券投资,投资机构,徳讯证券,徳讯证顾',
        // description:'粤港澳大湾区的专业证券顾问机构,致力于为中国投资人孵化财富,为非专业人搭建学习平台,让每个人都能成为合格的投资者666.'
      }
      /* 打非详情 */
    },
    {
      path: '/about',
      name: 'about',
      component: about,
      meta: {
        title: '财富在线——金融科技领域湾区标杆',
        // keywords: '证券投资,投资机构,徳讯证券,徳讯证顾',
        // description:'粤港澳大湾区的专业证券顾问机构,致力于为中国投资人孵化财富,为非专业人搭建学习平台,让每个人都能成为合格的投资者666.'
      }
    },
    {
      path: '/B04_djzl',
      name: 'B04_djzl',
      component: B04_djzl,
      meta: {
        title: '财富在线——金融科技领域湾区标杆',
        // keywords: '证券投资,投资机构,徳讯证券,徳讯证顾',
        // description:'粤港澳大湾区的专业证券顾问机构,致力于为中国投资人孵化财富,为非专业人搭建学习平台,让每个人都能成为合格的投资者666.'
      }
      /* 党建专栏详情 */
    },
    {
      path: '/B05_gsdt',
      name: 'B05_gsdt',
      component: B05_gsdt,
      meta: {
        title: '财富在线——金融科技领域湾区标杆',
        // keywords: '证券投资,投资机构,徳讯证券,徳讯证顾',
        // description:'粤港澳大湾区的专业证券顾问机构,致力于为中国投资人孵化财富,为非专业人搭建学习平台,让每个人都能成为合格的投资者666.'
      }
      /* 公司动态详情 */
    },
    {
      path: '/B08_cpyc',
      name: 'B08_cpyc',
      component: B08_cpyc,
      meta: {
        title: '财富在线——金融科技领域湾区标杆',
        // keywords: '证券投资,投资机构,徳讯证券,徳讯证顾',
        // description:'粤港澳大湾区的专业证券顾问机构,致力于为中国投资人孵化财富,为非专业人搭建学习平台,让每个人都能成为合格的投资者666.'
      }
      /* 加入我们详情 */
    },
    {
      path: '/B10_xgsm',
      name: 'B10_xgsm',
      component: B10_xgsm,
      meta: {
        title: '财富在线——金融科技领域湾区标杆',
        // keywords: '证券投资,投资机构,徳讯证券,徳讯证顾',
        // description:'粤港澳大湾区的专业证券顾问机构,致力于为中国投资人孵化财富,为非专业人搭建学习平台,让每个人都能成为合格的投资者666.'
      }
      /* 相关声明详情 */
    },
    {
      path: '/teacherVideo',
      name: 'teacherVideo',
      component: teacherVideo,
      meta: {
        title: '财富在线——金融科技领域湾区标杆',
        // keywords: '证券投资,投资机构,徳讯证券,徳讯证顾',
        // description:'粤港澳大湾区的专业证券顾问机构,致力于为中国投资人孵化财富,为非专业人搭建学习平台,让每个人都能成为合格的投资者666.'
      }
    },
    {
      path: '/subjectVideo',
      name: 'subjectVideo',
      component: subjectVideo,
      meta: {
        title: '财富在线——金融科技领域湾区标杆',
        // keywords: '证券投资,投资机构,徳讯证券,徳讯证顾',
        // description:'粤港澳大湾区的专业证券顾问机构,致力于为中国投资人孵化财富,为非专业人搭建学习平台,让每个人都能成为合格的投资者666.'
      }
    },
    // 产品中心
    { //大德周报
      path: '/ddzb',
      name: 'ddzb',
      component: ddzb,
      meta: {
        title: '财富在线——金融科技领域湾区标杆',
        // keywords: '证券投资,投资机构,徳讯证券,徳讯证顾',
        // description:'粤港澳大湾区的专业证券顾问机构,致力于为中国投资人孵化财富,为非专业人搭建学习平台,让每个人都能成为合格的投资者666.'
      }
    },
    { //主题策略
      path: '/ztcl',
      name: 'ztcl',
      component: ztcl,
      meta: {
        title: '财富在线——金融科技领域湾区标杆',
        // keywords: '证券投资,投资机构,徳讯证券,徳讯证顾',
        // description:'粤港澳大湾区的专业证券顾问机构,致力于为中国投资人孵化财富,为非专业人搭建学习平台,让每个人都能成为合格的投资者666.'
      }
    },
    { //德迅算法
      path: '/dxsf',
      name: 'dxsf',
      component: dxsf,
      meta: {
        title: '财富在线——金融科技领域湾区标杆',
        // keywords: '证券投资,投资机构,徳讯证券,徳讯证顾',
        // description:'粤港澳大湾区的专业证券顾问机构,致力于为中国投资人孵化财富,为非专业人搭建学习平台,让每个人都能成为合格的投资者666.'
      }
    },
    { //德迅证顾
      path: '/dxzg',
      name: 'dxzg',
      component: dxzg,
      meta: {
        title: '财富在线——金融科技领域湾区标杆',
        // keywords: '证券投资,投资机构,徳讯证券,徳讯证顾',
        // description:'粤港澳大湾区的专业证券顾问机构,致力于为中国投资人孵化财富,为非专业人搭建学习平台,让每个人都能成为合格的投资者666.'
      }
    },
    { //交易师
      path: '/jys',
      name: 'jys',
      component: jys,
      meta: {
        title: '财富在线——金融科技领域湾区标杆',
        // keywords: '证券投资,投资机构,徳讯证券,徳讯证顾',
        // description:'粤港澳大湾区的专业证券顾问机构,致力于为中国投资人孵化财富,为非专业人搭建学习平台,让每个人都能成为合格的投资者666.'
      }
    },
    { //诊股大师
      path: '/zgds',
      name: 'zgds',
      component: zgds,
      meta: {
        title: '财富在线——金融科技领域湾区标杆',
        // keywords: '证券投资,投资机构,徳讯证券,徳讯证顾',
        // description:'粤港澳大湾区的专业证券顾问机构,致力于为中国投资人孵化财富,为非专业人搭建学习平台,让每个人都能成为合格的投资者666.'
      }
    },
    { //大德专属
      path: '/ddzs',
      name: 'ddzs',
      component: ddzs,
      meta: {
        title: '财富在线——金融科技领域湾区标杆',
        // keywords: '证券投资,投资机构,徳讯证券,徳讯证顾',
        // description:'粤港澳大湾区的专业证券顾问机构,致力于为中国投资人孵化财富,为非专业人搭建学习平台,让每个人都能成为合格的投资者666.'
      }
    },
    { //大德精研
      path: '/ddjy',
      name: 'ddjy',
      component: ddjy,
      meta: {
        title: '财富在线——金融科技领域湾区标杆',
        // keywords: '证券投资,投资机构,徳讯证券,徳讯证顾',
        // description:'粤港澳大湾区的专业证券顾问机构,致力于为中国投资人孵化财富,为非专业人搭建学习平台,让每个人都能成为合格的投资者666.'
      }
    },
    //股宇宙
    { //股宇宙下载页
      path: '/gyzxz',
      name: 'gyzxz',
      component: gyzxz,
      meta: {
        title: '财富在线——金融科技领域湾区标杆',
        // keywords: '证券投资,投资机构,徳讯证券,徳讯证顾',
        // description:'粤港澳大湾区的专业证券顾问机构,致力于为中国投资人孵化财富,为非专业人搭建学习平台,让每个人都能成为合格的投资者666.'
      }
    },
    {
      path: '/C01_dcjys',
      name: 'C01_dcjys',
      component: C01_dcjys,
      meta: {
        title: '财富在线——金融科技领域湾区标杆',
        // keywords: '证券投资,投资机构,徳讯证券,徳讯证顾',
        // description:'粤港澳大湾区的专业证券顾问机构,致力于为中国投资人孵化财富,为非专业人搭建学习平台,让每个人都能成为合格的投资者666.'
      }
      /* 德才院隐私 */
    },

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js